import {Action} from '@ngrx/store';
import {Device, DeviceId} from '../../shared/models/device';

export const DEVICES_USER_FETCHED = '[Devices] fetched all for user';
export const DEVICE_FETCHED = '[Devices] fetched device';
export const DEVICE_CREATED = '[Devices] created new device';
export const DEVICE_UPDATED = '[Devices] updated device';
export const DEVICE_DELETED = '[Devices] deleted device';

export class DevicesUserFetchedAction implements Action {
  readonly type = DEVICES_USER_FETCHED;

  constructor(public devices: Device[]) {
  }
}

export class DeviceFetchedAction implements Action {
  readonly type = DEVICE_FETCHED;

  constructor(public device: Device) {
  }
}

export class DeviceCreatedAction implements Action {
  readonly type = DEVICE_CREATED;

  constructor(public device: Device) {
  }
}

export class DeviceUpdatedAction implements Action {
  readonly type = DEVICE_UPDATED;

  constructor(public device: Device) {
  }
}

export class DeviceDeletedAction implements Action {
  readonly type = DEVICE_DELETED;

  constructor(public deviceId: DeviceId) {
  }
}


export type Actions = DevicesUserFetchedAction
  | DeviceFetchedAction
  | DeviceCreatedAction
  | DeviceUpdatedAction
  | DeviceDeletedAction
